export const PHONE_NUMBERS = [
  { display: '0850 242 73 63', tel: '+908502427363' },
  { display: '0532 334 56 96', tel: '+905323345696' },
  { display: '0532 565 54 79', tel: '+905325655479' },
]

export const CONTACT_EMAIL = 'besturizm@hotmail.com'
